'use client'

import { useTranslations } from 'next-intl'
import { usePathname } from '@/navigation'
import { cn } from '@/shared/helpers/styles.helper'
import { Button } from '@/shared/ui/button'
import { ArrowLeftIcon } from '@/shared/components/icons'
import { pagesAfterPayment } from '@/workflows/steps'
import { useNavigation } from '@/workflows/useNavigation'

interface BackButtonProps {
  // Arrow alone, at the top left of the header on mobile
  iconOnly?: boolean
  className?: string
}

// Opens the previous step; absent on the first step and on the pages after the payment
const BackButton: React.FC<BackButtonProps> = ({ iconOnly, className }) => {
  const t = useTranslations('common')
  const pathname = usePathname()
  const { previousPath, goToPreviousStep } = useNavigation()

  if (!previousPath || pagesAfterPayment.includes(pathname)) return null

  return (
    <Button
      variant='white-flat'
      size={iconOnly ? 'icon' : 'default'}
      aria-label={iconOnly ? t('back') : undefined}
      onClick={goToPreviousStep}
      className={cn('bg-blue-100', iconOnly && 'size-11', className)}
    >
      <ArrowLeftIcon aria-hidden data-icon='inline-start' />
      {!iconOnly && t('back')}
    </Button>
  )
}

export default BackButton
